/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: UptbiEIDaA4H

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import SectionHeader from "../../SectionHeader"; // plasmic-import: BZA1gY3bmqLJ/component
import HomeBenefitsSectionRoleDropdown from "../../HomeBenefitsSectionRoleDropdown"; // plasmic-import: qafHkE927CrC/component
import HomeBenefitsSectionBenefits from "../../HomeBenefitsSectionBenefits"; // plasmic-import: 2xx-2Vrj4B1-/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicHomeBenefitsSection.module.css"; // plasmic-import: UptbiEIDaA4H/css

createPlasmicElementProxy;

export type PlasmicHomeBenefitsSection__VariantMembers = {};
export type PlasmicHomeBenefitsSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomeBenefitsSection__VariantsArgs;
export const PlasmicHomeBenefitsSection__VariantProps =
  new Array<VariantPropType>();

export type PlasmicHomeBenefitsSection__ArgsType = {};
type ArgPropType = keyof PlasmicHomeBenefitsSection__ArgsType;
export const PlasmicHomeBenefitsSection__ArgProps = new Array<ArgPropType>();

export type PlasmicHomeBenefitsSection__OverridesType = {
  benefits?: Flex__<"section">;
  wrapper5?: Flex__<"div">;
  top6?: Flex__<"div">;
  sectionHeader?: Flex__<typeof SectionHeader>;
  col6?: Flex__<"div">;
  role?: Flex__<"div">;
  tagline?: Flex__<"h4">;
  roleDropdown?: Flex__<typeof HomeBenefitsSectionRoleDropdown>;
  freeBox?: Flex__<"div">;
  homeBenefitsSectionBenefits?: Flex__<typeof HomeBenefitsSectionBenefits>;
};

export interface DefaultHomeBenefitsSectionProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeBenefitsSection__RenderFunc(props: {
  variants: PlasmicHomeBenefitsSection__VariantsArgs;
  args: PlasmicHomeBenefitsSection__ArgsType;
  overrides: PlasmicHomeBenefitsSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "roleDropdown.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "opacity",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "100"
      },
      {
        path: "selectedRole",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "director"
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"benefits"}
      data-plasmic-override={overrides.benefits}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.benefits
      )}
    >
      <div
        data-plasmic-name={"wrapper5"}
        data-plasmic-override={overrides.wrapper5}
        className={classNames(projectcss.all, sty.wrapper5)}
      >
        <div
          data-plasmic-name={"top6"}
          data-plasmic-override={overrides.top6}
          className={classNames(projectcss.all, sty.top6)}
        >
          <SectionHeader
            data-plasmic-name={"sectionHeader"}
            data-plasmic-override={overrides.sectionHeader}
            className={classNames("__wab_instance", sty.sectionHeader)}
            showSubtitle={true}
            subtitle={"Key Benefits"}
            title={(() => {
              try {
                return "Why MyEvaluations? \nUnraveling Organizational and Faculty Benefits";
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return undefined;
                }
                throw e;
              }
            })()}
          />

          <div
            data-plasmic-name={"col6"}
            data-plasmic-override={overrides.col6}
            className={classNames(projectcss.all, sty.col6)}
          >
            <div
              data-plasmic-name={"role"}
              data-plasmic-override={overrides.role}
              className={classNames(projectcss.all, sty.role)}
            >
              <h4
                data-plasmic-name={"tagline"}
                data-plasmic-override={overrides.tagline}
                className={classNames(
                  projectcss.all,
                  projectcss.h4,
                  projectcss.__wab_text,
                  sty.tagline
                )}
              >
                {"Switch to Your Role"}
              </h4>
              <HomeBenefitsSectionRoleDropdown
                data-plasmic-name={"roleDropdown"}
                data-plasmic-override={overrides.roleDropdown}
                className={classNames("__wab_instance", sty.roleDropdown)}
                onValueChange={async (...eventArgs: any) => {
                  generateStateOnChangeProp($state, [
                    "roleDropdown",
                    "value"
                  ]).apply(null, eventArgs);

                  if (
                    eventArgs.length > 1 &&
                    eventArgs[1] &&
                    eventArgs[1]._plasmic_state_init_
                  ) {
                    return;
                  }

                  (async val => {
                    const $steps = {};

                    $steps["runCode"] = true
                      ? (() => {
                          const actionArgs = {
                            customFunction: async () => {
                              return (() => {
                                $state.opacity = 0;
                                setTimeout(() => {
                                  $state.opacity = 100;
                                }, 200);
                                return setTimeout(() => {
                                  $state.selectedRole = val;
                                }, 200);
                              })();
                            }
                          };
                          return (({ customFunction }) => {
                            return customFunction();
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["runCode"] != null &&
                      typeof $steps["runCode"] === "object" &&
                      typeof $steps["runCode"].then === "function"
                    ) {
                      $steps["runCode"] = await $steps["runCode"];
                    }
                  }).apply(null, eventArgs);
                }}
              />
            </div>
          </div>
        </div>
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox)}
          style={(() => {
            try {
              return {
                opacity: $state.opacity
              };
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })()}
        >
          <HomeBenefitsSectionBenefits
            data-plasmic-name={"homeBenefitsSectionBenefits"}
            data-plasmic-override={overrides.homeBenefitsSectionBenefits}
            className={classNames(
              "__wab_instance",
              sty.homeBenefitsSectionBenefits
            )}
            pov={(() => {
              try {
                return $state.selectedRole;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return "director";
                }
                throw e;
              }
            })()}
          />
        </div>
      </div>
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  benefits: [
    "benefits",
    "wrapper5",
    "top6",
    "sectionHeader",
    "col6",
    "role",
    "tagline",
    "roleDropdown",
    "freeBox",
    "homeBenefitsSectionBenefits"
  ],
  wrapper5: [
    "wrapper5",
    "top6",
    "sectionHeader",
    "col6",
    "role",
    "tagline",
    "roleDropdown",
    "freeBox",
    "homeBenefitsSectionBenefits"
  ],
  top6: ["top6", "sectionHeader", "col6", "role", "tagline", "roleDropdown"],
  sectionHeader: ["sectionHeader"],
  col6: ["col6", "role", "tagline", "roleDropdown"],
  role: ["role", "tagline", "roleDropdown"],
  tagline: ["tagline"],
  roleDropdown: ["roleDropdown"],
  freeBox: ["freeBox", "homeBenefitsSectionBenefits"],
  homeBenefitsSectionBenefits: ["homeBenefitsSectionBenefits"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  benefits: "section";
  wrapper5: "div";
  top6: "div";
  sectionHeader: typeof SectionHeader;
  col6: "div";
  role: "div";
  tagline: "h4";
  roleDropdown: typeof HomeBenefitsSectionRoleDropdown;
  freeBox: "div";
  homeBenefitsSectionBenefits: typeof HomeBenefitsSectionBenefits;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeBenefitsSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeBenefitsSection__VariantsArgs;
    args?: PlasmicHomeBenefitsSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomeBenefitsSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomeBenefitsSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomeBenefitsSection__ArgProps,
          internalVariantPropNames: PlasmicHomeBenefitsSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeBenefitsSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "benefits") {
    func.displayName = "PlasmicHomeBenefitsSection";
  } else {
    func.displayName = `PlasmicHomeBenefitsSection.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeBenefitsSection = Object.assign(
  // Top-level PlasmicHomeBenefitsSection renders the root element
  makeNodeComponent("benefits"),
  {
    // Helper components rendering sub-elements
    wrapper5: makeNodeComponent("wrapper5"),
    top6: makeNodeComponent("top6"),
    sectionHeader: makeNodeComponent("sectionHeader"),
    col6: makeNodeComponent("col6"),
    role: makeNodeComponent("role"),
    tagline: makeNodeComponent("tagline"),
    roleDropdown: makeNodeComponent("roleDropdown"),
    freeBox: makeNodeComponent("freeBox"),
    homeBenefitsSectionBenefits: makeNodeComponent(
      "homeBenefitsSectionBenefits"
    ),

    // Metadata about props expected for PlasmicHomeBenefitsSection
    internalVariantProps: PlasmicHomeBenefitsSection__VariantProps,
    internalArgProps: PlasmicHomeBenefitsSection__ArgProps
  }
);

export default PlasmicHomeBenefitsSection;
/* prettier-ignore-end */
